import { StartClient } from "@tanstack/react-start/client";
import { hydrateRoot } from "react-dom/client";

// P5 — Sentry.init foi movido para src/lib/client-bootstrap.ts e é agendado
// via requestIdleCallback. Manter Sentry aqui arrastava ~70KB gzipped para
// o bundle de hidratação (crítico). Service worker também é registrado lá.

hydrateRoot(document, <StartClient />);
